import { ApiError, isTermsAcceptanceRequiredError } from "@/shared/domain/api-error";
import { registerHttpErrorInterceptor } from "@/shared/infrastructure/http/http-client";
import type { PendingTerm } from "../domain/entities";

export type TermsRequiredListener = (pending?: PendingTerm[]) => void;

const listeners = new Set<TermsRequiredListener>();

export function subscribeToTermsRequired(listener: TermsRequiredListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifyTermsAcceptanceRequired(pending?: PendingTerm[]): void {
  listeners.forEach((listener) => {
    try {
      listener(pending);
    } catch (err) {
      console.error("TermsRequiredListener error", err);
    }
  });
}

export { isTermsAcceptanceRequiredError };

export function extractPendingTermsFromError(error: unknown): PendingTerm[] | null {
  if (isTermsAcceptanceRequiredError(error)) {
    const details = (error as ApiError).details as {
      details?: { pending?: PendingTerm[] };
    };
    return details?.details?.pending ?? null;
  }
  return null;
}

// Automatically register HTTP interceptor for 403 TERMS_ACCEPTANCE_REQUIRED
registerHttpErrorInterceptor((response: Response, details?: unknown) => {
  if (response.status === 403) {
    const payload = details as {
      error?: string;
      details?: { pending?: PendingTerm[] };
    } | undefined;
    if (payload?.error === "TERMS_ACCEPTANCE_REQUIRED") {
      notifyTermsAcceptanceRequired(payload.details?.pending);
    }
  }
});
